// extracted by mini-css-extract-plugin
module.exports = {"Main":"Main_Main__a0bqM","Main_withNavigationLeftContainer":"Main_Main_withNavigationLeftContainer__eo5oJ","Main_article":"Main_Main_article__s_yVT"};